import styles from './publication-card.module.scss';
import { routeForDocument } from 'lib/routes';
import { Link } from 'src/navigation';
import MarkdownParser from 'components/rich-text/markdown-parser';
import Badge from 'components/badge';
import { PublicationCardImage } from './image';
import { type Image } from '@metmuseum/types';

const PublicationCard = ({ publication }: Props) => {
	const { title, slug, _type, coverImage, pdf, pdfUrl, datePublished } =
		publication;

	return (
		<div className={styles.card}>
			<PublicationCardImage slug={slug} _type={_type} coverImage={coverImage} />
			<div className={styles.body}>
				<h4 className={styles.heading}>
					<Link href={routeForDocument({ slug: slug, _type: _type })}>
						<MarkdownParser>{title}</MarkdownParser>
					</Link>
				</h4>
				{datePublished && (
					<div className={styles.date}>{datePublished.split('-')[0]}</div>
				)}
			</div>

			{(pdf || pdfUrl) && (
				<div className={styles.badgeWrapper}>
					<Badge text="Free to download" color="var(--color-grey-900)" />
				</div>
			)}
		</div>
	);
};

export interface PublicationCardProps {
	_id: string;
	_type: string;
	title: string;
	coverImage: Image;
	datePublished: string;
	pdf?: { size: number; url: string };
	pdfUrl?: string;
	slug: {
		current: string;
	};
}

interface Props {
	publication: PublicationCardProps;
}

export default PublicationCard;
